import { CombinedLogger } from "./combinedLogger";
import { ConsoleLogger } from "./consoleLogger";

export * from "./combinedLogger";
export * from "./consoleLogger";
export * from "./types";

export const logger = new CombinedLogger(new ConsoleLogger());
